module.exports = __webpack_public_path__ + "img/apple-store-badge.7ce21962.svg";